import { isNone } from '@ember/utils';
import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
export default BaseFragmentSerializer.extend({
  serialize(snapshot, options) {
    const json = this._super(snapshot, options);
    if (isNone(json.int_value)) {
      delete json.int_value;
    }
    if (isNone(json.string_value)) {
      delete json.string_value;
    }
    return json;
  }
});